<template>
    <div class="flex el-col-sm-24">
        <DateTimePicker
            class="flex"
            v-on:input="changeDate"
            :value="params.data[params.colDef.field]"
            :placeholder="$t('seller.sell.SellModal.StartTime')"
        ></DateTimePicker>
    </div>
</template>
<script>
import DateTimePicker from "@/components/templates/DateTimePicker";

export default {
    components: {
        DateTimePicker
    },
    methods: {
        changeDate(e) {
            let { data, colDef } = this.params;
            data[colDef.field] = e;
        }
    },
};
</script>

<style lang="scss" scoped>

.el-date-editor::v-deep {
    .el-input__inner {
        margin-left: 0 !important;
        margin-right: 0 !important;
        padding-left: 20px;
        padding-right: 0;
    }
}

</style>